import * as React from "react";
const SvgFiRrPiata = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pi\xF1ata_svg__a)">
      <path
        fill="#062147"
        d="M19 7h-6.5a.5.5 0 0 1-.5-.5 4.4 4.4 0 0 0-1-2.808v-.816A3 3 0 0 0 8.98.04.742.742 0 0 0 8 .742v1.286a6 6 0 0 0-.642-.03c-.358 0-1.121.13-1.437.23L2.254 3.552a3.42 3.42 0 0 0-1.948 1.77A3.4 3.4 0 0 0 .18 7.95c.312.87.975 1.566 1.916 2.012.248.116.736.304 2.105.582a1 1 0 0 1 .798.979v8.985a3.5 3.5 0 0 0 3.508 3.49A3.496 3.496 0 0 0 12 20.509v-.51h5v.515a3.497 3.497 0 0 0 3.483 3.492h.008c.93 0 1.805-.361 2.464-1.018a3.47 3.47 0 0 0 1.028-2.468L24 11.998c0-2.757-2.244-5-5-5zM4.599 8.584c-1.165-.236-1.542-.38-1.65-.431-.313-.148-.721-.421-.886-.878a1.43 1.43 0 0 1 .053-1.1 1.43 1.43 0 0 1 .816-.74l3.63-1.312c.143-.045.614-.096 1.01-.115C8.95 4.108 10 5.167 10 6.5A2.503 2.503 0 0 0 12.499 9h6.5c1.654 0 3 1.346 3 2.998v.037c-.686-.098-1.397.105-1.974.626l-1.32 1.194c-.211.19-.393.193-.604 0l-1.322-1.196c-.967-.875-2.32-.874-3.288 0l-1.32 1.194c-.211.193-.393.193-.604 0l-1.322-1.196c-.955-.861-2.281-.87-3.247-.03V11.52a3.006 3.006 0 0 0-2.401-2.94zM21.544 21.57c-.282.28-.655.435-1.053.435h-.003A1.494 1.494 0 0 1 19 20.514V19a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1.509c0 .822-.67 1.49-1.508 1.49A1.493 1.493 0 0 1 7 20.51v-5.187l1.3-1.178c.213-.191.395-.192.605 0l1.32 1.196a2.44 2.44 0 0 0 1.645.655c.58 0 1.16-.22 1.645-.656l1.32-1.194c.212-.192.393-.192.604 0l1.322 1.196c.969.873 2.32.874 3.288 0l1.32-1.194c.212-.193.393-.193.605 0 .006.006.015.007.023.013l-.014 6.359c0 .398-.157.773-.439 1.055z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pi\xF1ata_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPiata;
